export const BASE_CRM_API_URI = process.env.REACT_APP_CRM_API_URL;
export const IMAGE_BASE_PATH = process.env.REACT_APP_IMAGE_BASE_URL;